import { schema } from "normalizr";
import { ReplenishmentGroup } from "records/item";

export const ReplenishmentGroupSchema = new schema.Entity("replenishmentGroups", {});

(ReplenishmentGroupSchema as any).record = ReplenishmentGroup;
